import styled from 'styled-components';

export const Banner = styled.div`
  position: fixed;
  left: 0;
  right: 0;
  bottom: 24px;
  z-index: 10000;
  width: calc(100% - 48px);
  max-width: 760px;
  margin: 0 auto;
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 28px;
  padding: 26px 28px;
  border: 1px solid #d5deec;
  border-radius: 16px;
  background: #fff;
  color: #0f2137;
  box-shadow: 0 18px 56px rgba(15, 33, 55, 0.32);

  p {
    flex: 1;
    margin: 0;
    font-size: 15px;
    line-height: 1.55;
    color: #343d48;
  }

  p strong {
    display: block;
    margin-bottom: 4px;
    color: #0f2137;
    font-size: 18px;
  }

  a {
    color: #46679f;
    font-weight: 600;
    text-decoration: underline;
  }

  .current {
    display: block;
    margin-top: 4px;
    color: #5d646d;
    font-size: 13px;
  }

  .buttons {
    flex: none;
    display: flex;
    gap: 12px;
  }

  /* Reject and Accept are the same button on purpose. */
  button {
    width: 124px;
    min-height: 48px;
    padding: 0 18px;
    border: 2px solid #0f2137;
    border-radius: 6px;
    background: #fff;
    color: #0f2137;
    font-family: inherit;
    font-size: 15px;
    font-weight: 700;
    cursor: pointer;

    &:hover,
    &:focus-visible {
      background: #0f2137;
      color: #fff;
    }
  }

  /* Short laptop screens (1280x720, 1366x768): the same wide banner at the
     bottom centre, only with less padding and smaller type. It still covers
     the lower part of the hero. */
  @media (min-width: 576px) and (max-height: 820px) {
    bottom: 16px;
    width: calc(100% - 32px);
    gap: 22px;
    padding: 18px 22px;

    p {
      font-size: 14px;
      line-height: 1.5;
    }

    p strong {
      display: inline;
      margin: 0 6px 0 0;
      font-size: 16px;
    }

    .buttons button {
      width: 116px;
      min-height: 44px;
      font-size: 15px;
    }
  }

  /* Phones: full width at the bottom, rounded only at the top, buttons side
     by side under the text. */
  @media (max-width: 575px) {
    bottom: 0;
    width: 100%;
    flex-direction: column;
    align-items: stretch;
    gap: 12px;
    padding: 16px 18px calc(16px + env(safe-area-inset-bottom));
    border-bottom: none;
    border-radius: 16px 16px 0 0;

    p {
      flex: none;
      font-size: 13.5px;
      line-height: 1.5;
    }

    p strong {
      display: inline;
      margin: 0 6px 0 0;
      font-size: 15px;
    }

    .buttons button {
      flex: 1;
      width: auto;
      min-height: 46px;
      font-size: 15px;
    }
  }
`;
